var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaIconInstagramNobg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.58 99.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.28,0C13.21,0,0,13.19,0,29.28v41.02c0,16.07,13.19,29.28,29.28,29.28h41.02c16.07,0,29.28-13.19,29.28-29.28V29.28c0-16.07-13.19-29.28-29.28-29.28H29.28ZM29.28,9.05h41.02c11.19,0,20.23,9.04,20.23,20.23v41.02c0,11.19-9.04,20.23-20.23,20.23H29.28c-11.19,0-20.23-9.04-20.23-20.23V29.28c0-11.19,9.04-20.23,20.23-20.23ZM76.53,18.95c-2.28,0-4.1,1.82-4.1,4.1s1.82,4.1,4.1,4.1,4.1-1.82,4.1-4.1-1.82-4.1-4.1-4.1ZM49.79,22.63c-14.94,0-27.16,12.22-27.16,27.16s12.22,27.16,27.16,27.16,27.16-12.22,27.16-27.16-12.22-27.16-27.16-27.16ZM49.79,31.69c10.06,0,18.11,8.05,18.11,18.11s-8.05,18.11-18.11,18.11-18.11-8.05-18.11-18.11,8.05-18.11,18.11-18.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIconInstagramNobg);
export default __webpack_public_path__ + "static/media/Social_Media_Icon_Instagram_nobg.826fdbd8c7322073e38378f7b867336e.svg";
export { ForwardRef as ReactComponent };